import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Menu, SvgIcon, Tooltip } from '@mui/material';

import { ToolbarButton, menuPaperProps } from './GeneratikTableToolbar.styles';
import { placeholderTextSx } from './ToolbarFilterButton.styles';

interface ToolbarFilterButtonProps {
  collapsed: boolean;
  filterAnchor: HTMLElement | null;
  hasCustomFilterClick: boolean;
  onFilterClick: (event: React.MouseEvent<HTMLElement>) => void;
  onFilterClose: () => void;
}

const ToolbarFilterButton = forwardRef<HTMLButtonElement, ToolbarFilterButtonProps>(
  ({ collapsed, filterAnchor, hasCustomFilterClick, onFilterClick, onFilterClose }, ref) => {
    const { t } = useTranslation();

    return (
      <>
        <Tooltip title={collapsed ? t('filter') : ''} arrow disableHoverListener={!collapsed}>
          <ToolbarButton
            id="filter-button"
            ref={ref}
            collapsed={collapsed}
            startIcon={
              <SvgIcon viewBox="0 0 16 16" sx={{ width: '1rem', height: '1rem' }}>
                <path
                  d="M9.22786 10.8337C9.50401 10.8337 9.72786 11.0575 9.72786 11.3337C9.72786 11.6098 9.50401 11.8337 9.22786 11.8337H6.76693C6.49078 11.8337 6.26693 11.6098 6.26693 11.3337C6.26693 11.0575 6.49078 10.8337 6.76693 10.8337H9.22786ZM11.6895 7.50033C11.9656 7.50033 12.1895 7.72418 12.1895 8.00033C12.1895 8.27647 11.9656 8.50033 11.6895 8.50033H4.30534C4.0292 8.50033 3.80534 8.27647 3.80534 8.00033C3.80534 7.72418 4.0292 7.50033 4.30534 7.50033H11.6895ZM13.3307 4.16699C13.6069 4.16699 13.8307 4.39085 13.8307 4.66699C13.8307 4.94313 13.6069 5.16699 13.3307 5.16699H2.66406C2.38792 5.16699 2.16406 4.94313 2.16406 4.66699C2.16406 4.39085 2.38792 4.16699 2.66406 4.16699H13.3307Z"
                  fill="currentColor"
                />
              </SvgIcon>
            }
            endIcon={<KeyboardArrowDownIcon />}
            onClick={onFilterClick}
            data-testid="filter-button"
          >
            <span className="button-text">{t('filter')}</span>
          </ToolbarButton>
        </Tooltip>
        {!hasCustomFilterClick && (
          <Menu
            anchorEl={filterAnchor}
            open={Boolean(filterAnchor)}
            onClose={onFilterClose}
            slotProps={{
              paper: {
                sx: {
                  ...menuPaperProps.sx,
                  minWidth: '9.375rem',
                },
              },
            }}
          >
            <Box sx={placeholderTextSx}>{t('Filter options coming soon')}</Box>
          </Menu>
        )}
      </>
    );
  },
);

ToolbarFilterButton.displayName = 'ToolbarFilterButton';

export default ToolbarFilterButton;
